<template>
  <div class="car-card" @click="getCarDetail">
    <div class="new-car" v-show="showNewLabel">Novinka</div>
    <div class="state-offer" :class="{ reserved: !this.carData.SaleActive }">{{ this.carData.Stav }}</div>
    <div class="car-name">
      <h4>{{ this.carData.Name | trimName }}</h4>
    </div>
    <div class="car-detail">
      <div class="car-image">
        <img :src="carData.ImagePath" :alt="getTag" :title="getTag" />
      </div>
      <div class="car-data">
        <p class="data-item">
          <span class="item_title">Rok výroby:</span>
          <span>{{ this.carData.RokVyroby }}</span>
        </p>
        <p class="data-item">
          <span class="item_title">Najeto:</span>
          <span>{{ this.carData.Km }}</span>
        </p>

        <p class="data-item">
          <span class="item_title">Objem:</span>
          <span>{{ this.carData.Objem }}</span>
        </p>
        <p class="data-item">
          <span class="item_title">Výkon:</span>
          <span>{{ this.carData.Power }}</span>
        </p>
        <p class="car-price" v-show="carData.SaleActive">{{ this.carData.Price }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["carData"],
  methods: {
    getCarDetail() {
      if (this.$router.path != "/") this.$router.replace("/").catch(() => {});
      this.$router.replace("/" + this.carData.Id).catch(() => {});
    }
  },
  computed: {
    showNewLabel() {
      let dt1 = new Date(this.carData.Created);
      let dt2 = new Date();
      let days = Math.floor(
        (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
          Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
          (1000 * 60 * 60 * 24)
      );
      if (days < 14) return true;

      return false;
    },
    getTag() {
      return "Vozidlo - Evidenční číslo: " + this.carData.InternalNumber;
    }
  },
  filters: {
    trimName(value) {
      if (!value) return "";
      value = value.toString();
      if (value.length > 30) {
        value = value.substring(0, 29) + "...";
      }
      return value;
    },
    capitalize(value) {
      if (!value) return "";
      value = value.toString().toLowerCase();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    price(value) {
      if (!value) return "";
      let formatter = new Intl.NumberFormat("cs-CZ", {
        style: "currency",
        currency: "CZK"
      });
      return formatter.format(parseFloat(value));
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../scss/global.scss";
a {
  text-decoration: none;
}

.car-card {
  width: 90%;
  margin: 1rem;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  border-radius: 0.6rem;
  position: relative;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgb(107, 107, 107);
  cursor: pointer;
  color: $default-page-color;
  background-color: transparent;
  &:hover,
  &:active {
    box-shadow: -1px -1px 5px $default-page-color;
  }
  .car-name {
    height: 5rem;
    overflow: hidden;
    h4 {
      padding: 1.2rem 3.2rem;
    }
  }
  .new-car {
    width: 8rem;
    background-color: rgb(189, 176, 0);
    transform: rotate(-45deg);
    position: absolute;
    color: #fff;
    top: 1.2rem;
    left: -2.1rem;
    display: inline-block;
    text-align: center;
  }
  .state-offer {
    width: 8rem;
    background-color: rgb(52, 68, 209);
    transform: rotate(45deg);
    position: absolute;
    color: #fff;
    top: 1.2rem;
    right: -2.1rem;
    text-align: center;
    &.reserved {
      background-color: rgb(202, 68, 5);
    }
  }
  .car-detail {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
    padding: 0 0.5rem;
    .car-image {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-right: 0.5rem;
      img {
        width: 10rem;
        height: 7rem;
      }
    }
    .car-data {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      text-align: left;
      font-size: 0.9rem;
      width: 50%;
      p {
        margin: 0;
        padding: 0;
      }
      .data-item {
        display: flex;
        justify-content: space-between;
        .item_title {
          font-weight: 600;
        }
      }
      .car-price {
        display: inline-block;
        border-radius: 0 0 0.5rem 0;
        position: absolute;
        bottom: 0;
        right: 0;
        padding: 1rem;
        padding-right: 0.5rem;
        text-align: right;
        font-size: 1.3rem;
        font-weight: 700;
      }
    }
  }
}
@media (min-width: $min-width-extended) {
  .car-card {
    width: 28rem;

    .car-detail {
      .car-image {
        width: 15rem;
        img {
          width: 14rem;
          height: 10rem;
        }
      }
      .car-data {
        width: 11rem;
        padding-right: 0.5rem;
        .car-price {
          padding-right: 1rem;
        }
      }
    }
  }
}
</style>
